import extraInformation from "./extraInformation.component";

const extraInformationModule = angular
  .module("app.components.extraInformation", [])
  .component("extraInformation", extraInformation);

export default extraInformationModule;



// WEBPACK FOOTER //
// ./src/components/extraInformation/extraInformation.module.js